import React from 'react';
import { ImageOptimizer } from '@/components/seo/ImageOptimizer';
const TeamImage = () => {
  return (
    <div className="relative">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-transparent rounded-2xl transform rotate-2"></div>
      <ImageOptimizer 
        src="/lovable-uploads/f0ba75b8-4ded-477e-b7fb-724455226ad1.png"
        alt="Diverse team of SeniorThrive professionals collaborating in a modern office, showcasing teamwork and dedication"
        className=""
        imgClassName="relative w-full h-[400px] lg:h-[500px] object-cover rounded-2xl shadow-xl transform -rotate-1 hover:rotate-0 transition-transform duration-500"
        sizes="(min-width: 1024px) 600px, 100vw"
      />
    </div>
  );
};

export default TeamImage;